"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Button_1 = require("./Button");

var react_2 = require("@emotion/react");

var themes_1 = require("./themes");

var styled_1 = __importDefault(require("@emotion/styled"));

var MenuContent = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: ", ";\n  background: #fff;\n  flex-direction: column;\n  z-index: 99;\n  box-shadow: 1px 1px 5px rgba(157, 157, 157, 0.4);\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: ", ";\n  background: #fff;\n  flex-direction: column;\n  z-index: 99;\n  box-shadow: 1px 1px 5px rgba(157, 157, 157, 0.4);\n"])), function (_a) {
  var open = _a.open;
  return open ? 'flex' : 'none';
}, function (_a) {
  var fullWidth = _a.fullWidth;
  return fullWidth ? 0 : 'auto';
});

exports.TopMenu = function (_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j;

  var label = _a.label,
      children = _a.children,
      content = _a.content,
      fullWidth = _a.fullWidth,
      props = __rest(_a, ["label", "children", "content", "fullWidth"]);

  var _k = react_1.useState(false),
      buttonHoover = _k[0],
      setButtonHoover = _k[1];

  var _l = react_1.useState(false),
      contentHoover = _l[0],
      setContentHoover = _l[1];

  var open = buttonHoover || contentHoover;
  var theme = react_2.useTheme();
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(Button_1.Button, __assign({}, props, {
    color: open ? (_e = (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.surface) === null || _d === void 0 ? void 0 : _d.onColor, _e !== null && _e !== void 0 ? _e : themes_1.defaultTheme.colors.surface.onColor) : 'inherit',
    background: open ? (_j = (_h = (_g = (_f = theme) === null || _f === void 0 ? void 0 : _f.colors) === null || _g === void 0 ? void 0 : _g.surface) === null || _h === void 0 ? void 0 : _h.color, _j !== null && _j !== void 0 ? _j : themes_1.defaultTheme.colors.surface.color) : 'transparent',
    margin: "0",
    borderRadius: "0",
    onClick: function onClick() {
      return setButtonHoover(true);
    },
    onMouseOver: function onMouseOver() {
      return setButtonHoover(true);
    },
    onMouseOut: function onMouseOut() {
      return setButtonHoover(false);
    }
  }), label && (typeof label === 'string' ? label : label())), react_1.default.createElement(MenuContent, {
    open: open,
    fullWidth: fullWidth,
    onMouseOver: function onMouseOver() {
      return setContentHoover(true);
    },
    onMouseOut: function onMouseOut() {
      return setContentHoover(false);
    }
  }, content && content(), children));
};

var templateObject_1;